@if (moreDetails) {
  <h2 mat-dialog-title>More Details</h2>
}
<div mat-dialog-content>
  <div class="container-fluid">
    <div class="row">
      @if (moreDetails) {
        <div class="col-12">
          @for (item of moreDetails?.searchTerms; track item; let i = $index) {
            <div class="width-100">
              <div class="width-100">
                <span value="key"> Search Term: </span>
                <span value="value">
                  <strong>{{ item.searchTerm }}</strong>
                </span>
                <span value="key"> Search Index: </span>
                <span value="value">
                  <strong>{{ item.searchIndex }}</strong>
                </span>
                <span value="key"> Phrase Type: </span>
                <span value="value">
                  <strong>{{ item.queryOption }}</strong>
                </span>
                <span value="key"> Operator: </span>
                <span value="value">
                  <strong>{{ item.operator }}</strong>
                </span>
              </div>
              @if (i === 0) {
                <div class="width-100">
                  @for (l of moreDetails?.libraries; track l) {
                    <div class="width-100">
                      <span value="key"> Libraries: </span>
                      <span value="value">
                        <strong>{{ l }}</strong>
                      </span>
                    </div>
                  }
                  @for (y of moreDetails?.yearOfPub; track y) {
                    <div class="width-100">
                      <span value="key"> Year of Publication: </span>
                      <span value="value">
                        <strong> {{ y }}</strong>
                      </span>
                    </div>
                  }
                  @for (f of moreDetails?.formats; track f) {
                    <div class="width-100">
                      <span value="key"> Formats: </span>
                      <span value="value">
                        <strong> {{ f }}</strong>
                      </span>
                    </div>
                  }
                  @for (a of moreDetails?.audiences; track a) {
                    <div class="width-100">
                      <span value="key"> Audience Level: </span>
                      <span value="value">
                        <strong> {{ a }}</strong>
                      </span>
                    </div>
                  }
                  @for (r of moreDetails?.resources; track r) {
                    <div class="width-100">
                      <span value="key"> Resource(s): </span>
                      <span value="value">
                        <strong> {{ r }}</strong>
                      </span>
                    </div>
                  }
                  @if (moreDetails?.dateItemsAdded) {
                    <div class="width-100">
                      <span value="key"> Date of Item Added: </span>
                      <span value="value">
                        <strong> {{ moreDetails?.dateItemsAdded }}</strong>
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button
    mat-button
    role="button"
    type="button"
    aria-label="Close"
    cdkFocusInitial
    (click)="close()"
  >
    Close
  </button>
</div>
